module.exports = __webpack_public_path__ + "img/user.388ba4e7.svg";